/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import ContactSupport from "@material-ui/icons/ContactSupport";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import withStyles from "@material-ui/core/styles/withStyles";

import { MadeWithLove } from "components/MadeWithLove/MadeWithLove.jsx";
import ContactForm from "components/ContactForm/ContactForm.jsx";
import signupStyle from "assets/jss/material-dashboard-react/layouts/signupStyle.jsx";

class SupportPage extends Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <ContactSupport />
          </Avatar>
          <Typography component="h1" variant="h5">
            Contact Us
          </Typography>
          <ContactForm showTitle={false} />
          <Grid container justify="flex-end" style={{ marginTop: 16 }}>
            <Grid item>
              <Link href="signin" variant="body2">
                Sign in
              </Link>
            </Grid>
          </Grid>
        </div>
        <Box mt={5}>
          <MadeWithLove />
        </Box>
      </Container>
    );
  }
}

export default withStyles(signupStyle)(SupportPage);
